import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const AuditAction = ({ baseUrl, disabled }) => (
  <RibbonMenu
    name="audit"
    icon="history"
    message="actions.audit"
    url={`${baseUrl}/audits`}
    className="aridhia-audit-action"
    disabled={disabled}
  />
);

export default AuditAction;
